import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { TID } from "@/lib/testIds";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: m[1] });
        if (setUser) setUser(data.user);
        const isStaff = ["admin", "analyst", "quality", "finance"].includes(data.user?.role);
        navigate(isStaff ? "/admin" : "/dashboard", { state: { user: data.user }, replace: true });
      } catch {
        navigate("/login?error=1", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div data-testid={TID.auth.callback} className="min-h-screen grid place-items-center">
      <div className="text-sm text-muted-foreground font-mono tracking-widest-2 uppercase">Signing you in…</div>
    </div>
  );
}
